import convertTarget from './convertTarget';

/**
 * Converts a LinkDefApiProps object to a CtaLinkType object.
 *
 * @param {LinkDefApiProps} source - The source object containing link properties.
 * @returns {QuoteLinkType} - The converted link object.
 */
const getLink = (source) => {
  return {
    href: source.url,
    target: convertTarget(source.target),
    text: source.text || source.url,
    title: source.title,
  };
};

export default getLink;
